<h1 class="title-modal-historic" mat-dialog-title>
  <strong>Historic of this function </strong>
  <mat-icon (click)="onClose()">close</mat-icon>
</h1>
<div class="container">
  <div fxFlexOffset="10px">
    <mat-form-field fxFlex="100%" fxFlex.xs="100%">
      <mat-label>Filter</mat-label>
      <input matInput [formControl]="search" placeholder="Ex. ium" />
    </mat-form-field>
  </div>
  <div class="historique-container" micScrollBar>
    @if (this.dataSource.data.length === 0) {
    <mic-spinner color="accent" [strokeWidth]="5"></mic-spinner>
    } @else {
    <mic-table [config]="tableConfig" [dataSource]="dataSource">
      <ng-container *micCellTemplate="let item; name: 'status'">
        <mat-icon [class]="item.status">{{ utilService.getTableRowStatusIcon(item.status) }}</mat-icon>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'file'">
        <a (click)="fileLink(item.id)" class="file_download"><mic-icon icon="file_download"></mic-icon></a>
      </ng-container>
      <ng-container *micRowDetail="let item">
        <div fxLayout="column" fxLayoutAlign="start start">
          @if (item.errorList !== undefined && item.errorList.length !== 0) { @for (error of item.errorList; track $index) {
          <ul>
            <li>
              <span><mic-icon class="warning" icon="warning"></mic-icon></span> The error is in the column {{ error.columnNumber }} in the
              line {{ error.line }}. The value does not respect the regular expression that must be used.
            </li>
          </ul>
          } } @else {
          <p>The file was inserted successfully</p>
          }
        </div>
      </ng-container>
    </mic-table>
    }
  </div>
</div>
